import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, AlertCircle } from "lucide-react";
import api from "./api";
import "./CreditPurchase.css";

const CreditPurchaseSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("processing");
  const [error, setError] = useState("");

  useEffect(() => {
    const verifyPayment = async () => {
      const sessionId = searchParams.get("session_id");
      console.log("session id", sessionId);
      if (!sessionId) {
        setError("Invalid session");
        return;
      }

      try {
        await api.post("/users/credits/verify", { sessionId });
        setStatus("success");
        // Redirect after 3 seconds
        setTimeout(() => {
          navigate("/dashboard");
        }, 3000);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to verify payment");
        setStatus("error");
      }
    };

    verifyPayment();
  }, [searchParams, navigate]);

  return (
    <div className="success-container">
      <div className="success-card">
        {status === "processing" && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
            <h2 className="mt-4 text-xl font-semibold">Verifying Payment...</h2>
          </div>
        )}

        {status === "success" && (
          <div className="text-center">
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
            <h2 className="mt-4 text-xl font-semibold text-green-700">
              Payment Successful!
            </h2>
            <p className="mt-2 text-gray-600">
              Your credits have been added to your account.
            </p>
            <p className="mt-4 text-sm text-gray-500">
              Redirecting to dashboard...
            </p>
          </div>
        )}

        {status === "error" && (
          <div className="text-center">
            <AlertCircle className="w-12 h-12 text-red-500 mx-auto" />
            <h2 className="mt-4 text-xl font-semibold text-red-700">
              Payment Verification Failed
            </h2>
            <p className="mt-2 text-red-600">{error}</p>
            <button
              onClick={() => navigate("/dashboard")}
              className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Return to Dashboard
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditPurchaseSuccess;
